// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1vwov","header":"Modal_header__3jdKb","closeIcon":"Modal_closeIcon__1IP48","content":"Modal_content__BZbGL","noHeader":"Modal_noHeader__2NUVh"};